import api from "@/utils/api";
import store from "@/store";
import Notify from 'quasar/src/plugins/notify/Notify.js';;

export function useTelegram() {
    const sendKeyboard = async (code) => {
        try {
            const response = await api.post('/api/v1/telegram/send_keyboard.php', {
                code,
                user_id: store.state.user.id
            })
            return true
        } catch (reason) {
            Notify.create({
                color: 'negative',
                message: `${reason.response.status}: ${reason.response.data.message}`,
                timeout: 0,
                actions: [{
                    label: 'X',
                    color: 'white',
                    handler: () => undefined
                }]
            })
            return false
        }
    }

    const sendNchzKeyboard = async () => {
        const success = await sendKeyboard('nchz')
    }

    const sendTokensKeyboard = async () => {
        const success = await sendKeyboard('tokens')
    }

    return {
        sendKeyboard,
        sendNchzKeyboard,
        sendTokensKeyboard
    }
}
